import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import { store } from './redux/index';
import { BrowserRouter } from 'react-router-dom';
import ScrollToTop from './components/templates/scrollToTop';
import { StateProvider } from './context/StateContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <BrowserRouter>
      <ScrollToTop />
      <StateProvider>
        <App />
      </StateProvider>
    </BrowserRouter>
  </Provider>
);

reportWebVitals();
